import { subscriptionPackageVersions, subscriptions } from '../subscription'
import { describeTable } from './describeTable'

describeTable(subscriptions, {
  description: `One maintenance contract (huoltosopimus) on one property, billed monthly through Stripe. Created as a 'proposal' when an offer is drafted or the customer starts checkout, and turned 'active' by the Stripe webhook once the first payment succeeds; the webhook also keeps status, prices and dates in sync afterwards.
Money: effective_price_monthly is the Stripe price the customer actually pays per month, GROSS (VAT 25.5 % included) and after discounts — divide by 1.255 for net. base_price_monthly is the undiscounted list total of the packages. Monthly recurring revenue (MRR) at a date = sum of effective_price_monthly over subscriptions that are status='active' AND start_date <= date AND (end_date IS NULL OR end_date >= date). sopimuskanta = active subscriptions' monthly price * 12; it is a run rate, not ordered work.
MRR is recognised once at monthly-summary level. Visits done under a subscription (visits.subscription_id set, visit_tasks.billing_type='subscription_included') bring 0 incremental revenue and look cost-only per visit — intentional, do not "fix" by adding the visit price.
Packages: join subscription_package_versions → service_package_versions for what the contract includes.`,
  columns: {
    propertyId:
      'The property covered; join properties → customers for the customer.',
    opportunityId: 'The CRM lead this contract was sold from, if any.',
    displayName:
      'Optional human label; usually NULL, fall back to the package names.',
    startDate:
      'Calendar date the contract begins (billing anchor). Counts for MRR from this day.',
    endDate:
      'Calendar date it ended or is scheduled to end; NULL = open-ended.',
    status:
      'proposal = drafted / checkout not completed, not revenue; active = billing and in force (the only status that counts in MRR and sopimuskanta); paused = temporarily suspended; cancelled = ended (churn).',
    stripeSubscriptionId:
      'Stripe subscription id; NULL on proposals that never reached checkout.',
    basePriceMonthly:
      'List price per month before discounts (sum of package version price * quantity), gross.',
    effectivePriceMonthly:
      'Price per month the customer pays after discounts, gross (VAT included). The MRR column.',
    additionalTerms: 'Free-text extra terms agreed with the customer.',
    termsAcceptedAt:
      'When the customer accepted the terms at checkout; NULL on proposals.',
    termsVersion: 'Version string of the terms accepted.',
  },
})

describeTable(subscriptionPackageVersions, {
  description:
    'Which service package versions a subscription contains, with quantity. One row per (subscription, package version). Join service_package_versions for the price and service_packages for the package name.',
  columns: {
    quantity:
      'How many of this package (e.g. two fireplaces = 2 x chimney package).',
    sortOrder: 'Display order only.',
  },
})
